export default __webpack_public_path__ + "static/media/annex11.c045242d.png";